export default __webpack_public_path__ + "static/media/placeholder.fc309c30.svg";